(function(){
  function cap(){
    var ps=document.querySelectorAll('.product__info .product-form__text p');
    for(var i=0;i<ps.length;i++){
      var p=ps[i];
      if(p.getAttribute('data-et-cap'))continue;
      var t=p.textContent;
      if(!/ships in \d+ business day/i.test(t))continue;
      var parts=t.split('·');
      var out=parts.map(function(s){
        var m=s.match(/^(\s*)(.*?)(\s*)$/);
        var core=m[2];
        if(!core)return s;
        return m[1]+core.charAt(0).toUpperCase()+core.slice(1)+m[3];
      }).join('·');
      p.textContent=out;
      p.setAttribute('data-et-cap','1');
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',cap);else cap();
  new MutationObserver(function(){cap();}).observe(document.body,{childList:true,subtree:true});
})();

/* -------------------------------------------------------------------------
   ELA TEILA 2026-09-07. Bakstelejimas i produkto nuotrauka atidaro
   priartinimo langa. TIK TELEFONE (<=999px). Veikia per visa nuotrauka.
   Braukimas i sonus lieka galerijai.

   Dvieju pirstu paleidiklis ISIMTAS: gestas prasideda puslapyje, o langas
   atsidaro su savo animacija, tad pirmas suemimas tik atidarydavo, o
   priartindavo tik antras. NEGRAZINTI be priezasties.
   ------------------------------------------------------------------------- */
(function(){
  if(!window.matchMedia||!window.matchMedia('(max-width: 999px)').matches)return;
  var sx=0, sy=0, st=0, moved=true, fired=false;
  function scope(el){return el&&el.closest?el.closest('.product__media-list-wrapper'):null;}
  function lightboxOpen(){return !!document.querySelector('.pswp--open, .pswp--visible');}
  function openZoom(w){
    if(fired||lightboxOpen())return;
    var btn=(w&&w.querySelector('.product__zoom-button'))||document.querySelector('.product__zoom-button');
    if(!btn)return;
    fired=true; btn.click();
    setTimeout(function(){fired=false;},800);
  }
  document.addEventListener('touchstart', function(e){
    if(lightboxOpen()){moved=true;return;}
    if(!scope(e.target)){moved=true;return;}
    if(e.touches.length!==1){moved=true;return;}
    var t=e.touches[0]; sx=t.clientX; sy=t.clientY; st=Date.now(); moved=false;
  }, {passive:true});
  document.addEventListener('touchmove', function(e){
    if(moved||!e.touches.length)return;
    if(e.touches.length>1){moved=true;return;}
    var t=e.touches[0];
    if(Math.abs(t.clientX-sx)>10||Math.abs(t.clientY-sy)>10) moved=true;
  }, {passive:true});
  document.addEventListener('touchend', function(e){
    if(moved||lightboxOpen())return;
    if(Date.now()-st>400)return;
    var w=scope(e.target); if(!w)return;
    if(e.target.closest('button, a, [role="button"], input, label'))return;
    openZoom(w);
  }, {passive:true});
})();

/* -------------------------------------------------------------------------
   ELA TEILA 2026-09-07. .et-ready - produkto blokas rodomas tik tada, kai
   telefono perdeliojimas baigtas. Pora su custom-mobile-z.css.

   DU PATAISYMAI po matavimu:
   1) Anksciau lyginau ir AUKSTI - jis kinta krentant nuotraukoms, tad
      islydis niekada neatrodydavo nurimes ir kaskart suveikdavo atsargine
      riba (.et-ready ties 885ms). Dabar lyginamos tik VIRSUTINES pozicijos:
      butent jos sokteli perdeliojant, o aukscio kitimas nieko nestumdo,
      nes galerija turi rezervuota vieta (padding-bottom 125%).
   2) Anksciau tikrinimas prasidedavo tik per DOMContentLoaded ir pridedavo
      ~150ms virsaus. Dabar paleidziamas is karto, o elementu nebuvimas
      tiesiog praleidziamas - taip pagaunam pati pirma rami kadra.

   CAP 650ms yra tik atsargine riba: jei JS nesuveiktu, turinys pasirodo vis
   tiek, tad tuscio puslapio rizikos nera. Desktope rodom is karto.
   ------------------------------------------------------------------------- */
(function(){
  var root=document.documentElement;
  function show(){ root.classList.add('et-ready'); }

  if(!window.matchMedia||!window.matchMedia('(max-width: 999px)').matches){ show(); return; }

  var CAP=650, STEP=40, t0=Date.now(), last=null, same=0, timer=null;

  function pos(){
    var a=document.querySelector('.product__info');
    var b=document.querySelector('.product__media-list-wrapper');
    if(!a&&!b)return null;
    var s='';
    if(a)s+=Math.round(a.getBoundingClientRect().top);
    if(b)s+='|'+Math.round(b.getBoundingClientRect().top);
    return s;
  }

  function tick(){
    if(Date.now()-t0>CAP){ clearInterval(timer); show(); return; }
    var p=pos();
    if(p===null)return;              /* dar nera ko matuoti - laukiam toliau */
    if(p===last){ same++; if(same>=2){ clearInterval(timer); show(); } }
    else { last=p; same=0; }
  }

  timer=setInterval(tick,STEP);      /* startuojam IS KARTO, nelaukiam DCL */
  tick();
  setTimeout(show, CAP+100);
})();
